import { useEffect, useRef } from "react";
import useAuth from "e3-common/hooks/useAuth";
import { useBoundStore } from "e3-common/store/useBoundStore";
import {useLocation} from "react-router-dom";
import { useToast } from 'e3-common/hooks/useToast';
import {getLocalStorageItem, removeLocalStorageItem} from "e3-common/utils/localStorageUtil";
import {LOCAL_STORAGE_KEYS} from "e3-common/constants/enumerates";

export function useIdleTimer(flag = false) {
    const { logout } = useAuth();
    const {userId,expiredCheck} = useBoundStore((state) => state.user);
    const timerRef = useRef(null);
    const location = useLocation();
    const minutes = Number(import.meta.env.VITE_SESSION_TIME);
    const timeout = isNaN(minutes) ? 1800000 : minutes * 60 * 1000;
    const { Error } = useToast();
    useEffect(() => {
        if(!userId || expiredCheck == 'Y') return;
        const startTimeOut = () => {
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                // 백드롭 숨기기
                document.querySelectorAll('.wj-popup-backdrop').forEach(el => {
                    el.style.display = 'none';
                });
                Error('세션이 만료되어 로그아웃 되었습니다.');
                logout(userId); // 로그아웃 실행
            }, timeout); // 1분
        };

        const events = ["mousemove", "keydown", "mousedown", "touchstart", "scroll"];
        events.forEach((e) => window.addEventListener(e, startTimeOut));

        startTimeOut();

        return () => {
            clearTimeout(timerRef.current);
            events.forEach((e) => window.removeEventListener(e, startTimeOut));
        };
    }, [userId,expiredCheck]);
}
